import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa0392c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pagination"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_pagination, {
    background: "",
    "current-page": $props.currentPage,
    "page-count": Math.ceil($props.total / $props.pageSize),
    "page-size": $props.pageSize,
    layout: "sizes,total, prev, pager, next,jumper",
    total: $props.total,
    onCurrentChange: $setup.handleCurrentChange,
    onSizeChange: $setup.handleSizeChange,
    "page-sizes": $props.pageSizes
  }, null, 8, ["current-page", "page-count", "page-size", "total", "onCurrentChange", "onSizeChange", "page-sizes"])]);
}